module.exports = __webpack_public_path__ + "img/banner_zhnp@2x.0eb14439.png";